// Single source of truth for the fallback map position.
//
// Used whenever the user's real location is unknown: permission denied, GPS
// timeout, an insecure context where navigator.geolocation is unavailable, or
// a platform where the geolocation callbacks never fire at all.
//
// Historically each screen carried its own hardcoded Bangkok literal and they
// had drifted apart (13.7649161/100.5357104 vs 13.7563/100.5018), so two parts
// of the same screen could disagree about where "here" was.

export const DEFAULT_MAP_CENTER = { lat: 13.7649161, lng: 100.5357104 }; // Bangkok

export const DEFAULT_MAP_ZOOM = 14;

// Half-span of the synthetic viewport used when the map never reports bounds
// of its own. ~0.045° ≈ 5 km at Bangkok's latitude, close to what a zoom-14
// phone viewport actually covers.
export const DEFAULT_BOUNDS_SPAN_DEG = 0.045;

/**
 * Build a {ne, sw} bounds box around a centre point.
 * Returns null for an unusable centre so callers can just guard on the result.
 */
export const boundsFromCenter = (center, span = DEFAULT_BOUNDS_SPAN_DEG) => {
  const lat = Number(center?.lat);
  const lng = Number(center?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  return {
    ne: { lat: lat + span, lng: lng + span },
    sw: { lat: lat - span, lng: lng - span },
  };
};

export default DEFAULT_MAP_CENTER;
